module.exports = __webpack_public_path__ + "img/add.8f6e277d.svg";